import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'

// Calculate and the return what the initial zoom should be for an image inside the Cropper component
export const getCropperZoom = (cropSize: { height: number; width: number }) => {
  const image = document.querySelector('.cropperImage') as HTMLImageElement

  // If the image hasn't been rendered, return default zoom value. It shouldn't happen, but adding this guard just in case
  if (!image) return 1

  const width = image.width
  const height = image.height

  const heightRatio = cropSize.height / height
  const widthRatio = cropSize.width / width

  return Math.max(heightRatio, widthRatio)
}

// Images passed to cropper must be 10 MB or less
export const readImage = (reader: FileReader, file: Blob) => {
  if (file.size < 10000000) {
    reader.readAsDataURL(file)
  } else {
    showToastMessage('The image is too big, please select one that is smaller than 10 MB', 'error')
  }
}

export const cropperImageClass = 'cropperImage'
